import { render } from "./TaxIndex.vue?vue&type=template&id=54f03698"
import script from "./TaxIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Tax/TaxIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54f03698"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54f03698', __exports__)) {
    api.reload('54f03698', __exports__)
  }
  
  module.hot.accept("./TaxIndex.vue?vue&type=template&id=54f03698", () => {
    api.rerender('54f03698', render)
  })

}


export default __exports__